export function getRandomNum(min, max){
    return Math.floor(Math.random() * (max - min) ) + min;
}
/* MAX excluded */